const withDevTools = typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION__;

class ReduxExtentionHelper {
  private devTools: any;

  /**
   *
   */
  constructor() {
    if (withDevTools) {
      this.devTools = (window as any).__REDUX_DEVTOOLS_EXTENSION__.connect();
    }
  }

  public sendAction(action: string, state: any): void {
    if (this.devTools) {
      this.devTools.send(action, state);
    }
  }
}

export const reduxExtentionHelper = new ReduxExtentionHelper();
